/**
 * トップページモジュール
 *
 * 各機能を個別のファイルに分割し、このファイルで統合しています
 */

import { debounce } from '../utils';
import { initFeatures } from './features';
import { initSeasons } from './seasons';
import { initActivities, initCourses } from './slides';
import { initAreas } from './areas';
import { initRanking } from './ranking';

/**
 * トップページの初期化
 * @param {jQuery} $ - jQuery
 */
export function initHome($) {
  if ($('body.home').length === 0) return;

  // 各セクションの初期化
  const features = initFeatures($);
  const seasons = initSeasons($);
  const activities = initActivities($);
  const courses = initCourses($);
  initAreas($);
  initRanking($);

  // リサイズ時のボタン位置再調整（デバウンス付き）
  const handleResize = debounce(() => {
    if (features) features.adjustButtonPosition();
    if (seasons) seasons.adjustButtonPosition();
    if (activities) activities.adjustButtonPosition();
    if (courses) courses.adjustButtonPosition();
  }, 150);

  $(window).on('resize', handleResize);
}
